import { create } from 'zustand';

interface ExchangesNumbers {
    numbers: number | null;
    setNumbers: (id: number | null) => void;
}

const useStoreID = create<ExchangesNumbers>((set) => ({
    numbers: null,
    setNumbers: (id) => set({ numbers: id }),
}));

export default useStoreID;
